import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {carouselEnum} from "@app/components/carousel/iCarousel";
import {environment} from "@env/environment";
import {SearchItemResponse} from "@app/app/search/isearch";
import {
  BrowserStorageService,
  CacheObjectService,
  DeviceService,
  EventTrackerService, HttpService,
  LogService,
  TypeShowLogInConsole
} from "@app/core";
import {ActivatedRoute, Router} from "@angular/router";
import {iBook} from "@app/interfaces/iBook";
import {IndicatorService} from "@app/shared";
import {finalize, map} from "rxjs/operators";

@Component({
  selector: 'navaar-search-library',
  templateUrl: './search-library.component.html',
  styleUrls: ['./search-library.component.scss']
})
export class SearchLibraryComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('txtbox', {static: true}) private input: ElementRef;
  public carousel: typeof carouselEnum = carouselEnum;

  public wordSearch: string = "";
  public isEnd: boolean = false;
  public readonly PAGE_SIZE = 20;
  public isLoading: boolean = false;
  public isEmptyResultSearch: boolean = false;
  public totalItem: number = 0;
  public items: Array<SearchItemResponse> = [];
  public itemsForEmptySearch: any = null;
  public itemsSearched: Array<string> = [];
  private readonly ITEM_SEARCH: string = "search_item";

  public get page(): number {
    return this.cache.pageNumer;
  }

  public set page(v: number) {
    this.cache.pageNumer = v;
  }

  constructor(
    public readonly device: DeviceService,
    public readonly storage: BrowserStorageService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly cache: CacheObjectService<Array<iBook>>,
    private readonly http: HttpService,
    private readonly log: LogService,
    private readonly indicator: IndicatorService,
    private readonly eventTracker: EventTrackerService) {
  }

  public async ngOnInit() {
    this.http.post('/api/library/search-history?$top=5', {}).subscribe(x => {
      this.itemsSearched = x.items as Array<string> || [];
    })
    this.indicator.hide();
    this.log.logger('search component ngOnInit START', TypeShowLogInConsole.info);
    this.wordSearch = this.route.snapshot.queryParamMap.get('q');
    if (this.wordSearch) await this.fetchData();
  }

  private async fetchData() {
    this.indicator.showHude();
    this.isLoading = true;
    this.isEmptyResultSearch = false;
    await this.http.post('/api/library/search?keyword=' + this.wordSearch.trim() + '&$skip=' + (this.page * this.PAGE_SIZE) + '&$top=' + this.PAGE_SIZE, {}).pipe(
      finalize(() => this.indicator.hideHude()),
      map((c) => {
        this.eventTracker.logEvent('search', {search_term: this.wordSearch, x_search_result_count: c.total});
        let allItem = [];
        allItem = c.items;

        if (this.page === 0) {
          this.items = [];
          this.items = allItem;
        }
        if (this.page > 0) {
          this.items = [...this.items, ...allItem];
        }

        this.isLoading = false;
        if (c.count) {
          this.isEnd = this.items.length === c.count;
          this.totalItem = c.count;
        } else {
          this.isEnd = allItem.length < this.PAGE_SIZE;
          this.totalItem = this.items.length;
        }
        if (this.totalItem === 0) {
            this.items = [];
            this.getItemsSlider();
            this.isEmptyResultSearch = true;
            return;
          }
        this.indicator.hideHude();
        if (!this.route.snapshot.queryParamMap.has('q') || !this.route.snapshot.queryParamMap.get('q').includes(this.wordSearch))
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {q: this.wordSearch},
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
      })).toPromise().then();
  }

  public async goToNextPage(page: number) {
    this.isLoading = true;
    this.page = page;
    await this.fetchData();
  }

  public onSearch(event: KeyboardEvent) {
    event.preventDefault();
    if (event.code === 'enter' || event.key === 'enter' || event.key === 'Enter' || event.which === 13 || event.keyCode === 13)
      this.search().then();
  }

  public async search() {
    this.indicator.showHude();
    this.itemsForEmptySearch = null;
    this.page = 0;
    this.isEnd = false;
    this.input.nativeElement.blur();
    if (this.wordSearch && this.wordSearch.length > 0) {
      await this.fetchData();
      if (!this.itemsSearched.includes(this.wordSearch)) {
        if (this.itemsSearched.length >= 5)
          this.itemsSearched.shift();
        this.itemsSearched.push(this.wordSearch);
        this.storage.setLocal(this.ITEM_SEARCH, this.itemsSearched);
      }
    } else {
      this.items = [];
      this.router.navigate(['/search'], {queryParams: null, replaceUrl: true});
      this.indicator.hideHude();
    }
  }

  public getItemsSlider() {
    this.cache.getObjectCache('api/audiobooks/bestseller?$top=8', `search---${this.wordSearch}`).subscribe(c => {
      this.indicator.hideHude();
      this.isLoading = false;
      this.itemsForEmptySearch = c;
    }, () => {
      this.indicator.hideHude();
      this.isLoading = false;
    })
  }

  goBack() {
    this.router.navigate(['./library']).then();
  }

  public searchSelectedHistoryItem(item: string) {
    this.wordSearch = item;
    this.search().then();
  }

  public ngAfterViewInit(): void {
    //  this.input.nativeElement.focus();
  }

  public ngOnDestroy() {
    this.indicator.show();
    this.indicator.hideHude();
  }
}
